<template>
  <v-dialog
    v-if="isActive"
    :value="isActive"
    @click:outside="closeDialog()"
    max-width="600"
    scrollable
  >
    <ValidationObserver v-slot="{ handleSubmit }">
      <v-card :loading="isLoading">
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              {{ isEditMode ? "Actualizar" : "Crear" }} Contacto
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text style="max-height: 370px">
            <v-row>
              <!-- Nombre -->
              <v-col cols="12" class="pb-0">
                <ValidationProvider
                  name="Nombre"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="payload.name"
                    :error-messages="errors"
                    label="Nombre"
                    prepend-inner-icon="mdi-card-account-details-outline"
                    rounded
                    filled
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <!-- Departamento -->
              <v-col cols="12" class="py-0">
                <ValidationProvider
                  name="Departamento"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-select
                    :items="departmentList"
                    v-model="payload.departament_id"
                    :error-messages="errors"
                    item-text="name"
                    item-value="id"
                    label="Departamento"
                    prepend-inner-icon="mdi-office-building"
                    rounded
                    filled
                  >
                  </v-select>
                </ValidationProvider>
              </v-col>
              <!-- Extension -->
              <v-col cols="12" class="py-0">
                <ValidationProvider
                  name="Extension "
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-autocomplete
                    v-model="payload.extension"
                    :error-messages="errors"
                    :items="extensionsList"
                    label="Extension"
                    prepend-inner-icon="mdi-call-split"
                    no-data-text="No hay extensiones para mostrar"
                    rounded
                    filled
                  ></v-autocomplete>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-card-text>
        </vuescroll>
        <v-card-actions>
          <v-btn
            @click="closeDialog()"
            class="px-8"
            color="error"
            rounded
            large
            text
          >
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn
            @click="handleSubmit(submitForm)"
            :disabled="isLoading"
            class="px-8"
            color="success"
            rounded
            large
          >
            {{ isEditMode ? "Actualizar" : "Crear" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";
export default {
  props: {
    isActive: {
      type: Boolean,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
    dataToEdit: {
      type: Object,
      default: {},
    },
    departmentList: {
      type: Array,
    },
  },
  components: { vuescroll },

  data() {
    return {
      payload: {
        name: "",
        departament_id: "",
        extension: "",
      },
      extensionsList: ["789"],
      isLoading: false,
    };
  },

  created() {
    if (this.isEditMode) this.payload = { ...this.dataToEdit };
    this.getExtensions();
  },

  methods: {
    async submitForm() {
      this.isLoading = true;
      const { id, ...payload } = this.payload;
      try {
        const { data } = this.isEditMode
          ? await PbxHttpClient.put(`/admin/directory/${id}`, payload)
          : await PbxHttpClient.post("/admin/directory", payload);

        this.closeDialog(data);
        this.$snotify.success("Registro creado con exito", "¡Hecho!");
      } catch (err) {
        this.$snotify.error("No se pudo guardar los cambios", "¡Error!");
      }

      this.isLoading = false;
    },

    async getExtensions() {
      try {
        const { data } = await PbxHttpClient.get(
          "/admin/list_extension/directory"
        );
        this.extensionsList = data;
        if (this.isEditMode)
          this.extensionsList = [
            ...this.extensionsList,
            this.dataToEdit.extension,
          ].sort();
      } catch (err) {
        // console.log(err);
        this.$snotify.error("No se pudo obtener las extensiones.", "¡Error!");
      }
    },

    closeDialog(data = false) {
      this.$emit("close:dialog", data);
    },
  },
};
</script>

<style></style>
